import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f5f05a6e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "opened"
};
var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 当前版本：");

var _hoisted_4 = {
  class: "details"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "开通时间：", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "到期时间：", -1);
});

var _hoisted_7 = {
  key: 0
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "使用期限：", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "剩余天数：", -1);
});

var _hoisted_10 = {
  class: "left-days"
};
var _hoisted_11 = {
  key: 1
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "可用账号：", -1);
});

var _hoisted_13 = {
  key: 2
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "已开通空间：", -1);
});

var _hoisted_15 = {
  key: 0,
  class: "spacelist"
};
var _hoisted_16 = {
  key: 1
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode("升级");

var _hoisted_18 = /*#__PURE__*/_createTextVNode("续费");

var _hoisted_19 = {
  key: 2,
  href: "https://buy.cloud.tencent.com/tbdt",
  target: "_blank",
  class: "go-more"
};
var _hoisted_20 = {
  key: 1,
  class: "introduce"
};
var _hoisted_21 = ["src"];
var _hoisted_22 = {
  class: "title"
};
var _hoisted_23 = {
  class: "title"
};
var _hoisted_24 = {
  class: "tags"
};
var _hoisted_25 = {
  class: "desc"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconxuanzhong"
  }, null, -1);
});

var _hoisted_27 = /*#__PURE__*/_createTextVNode("开通");

var _hoisted_28 = /*#__PURE__*/_createTextVNode("体验demo");

var _hoisted_29 = {
  class: "title"
};
var _hoisted_30 = {
  key: 0,
  class: "error"
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "该激活码非本产品激活码", -1);
});

var _hoisted_33 = [_hoisted_31, _hoisted_32];
var _hoisted_34 = {
  key: 1,
  class: "error"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconinfo"
  }, null, -1);
});

var _hoisted_36 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "激活码无效", -1);
});

var _hoisted_37 = [_hoisted_35, _hoisted_36];
var _hoisted_38 = {
  key: 2,
  class: "go-buy"
};

var _hoisted_39 = /*#__PURE__*/_createTextVNode(" 未获取激活码？");

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    href: "https://buy.cloud.tencent.com/tbdt",
    target: "_blank"
  }, "去购买", -1);
});

var _hoisted_41 = [_hoisted_39, _hoisted_40];
var _hoisted_42 = {
  class: "dialog-footer"
};

var _hoisted_43 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_44 = /*#__PURE__*/_createTextVNode("确定");

import { computed, ref } from 'vue';
import { appFeature, cloudAppInfoMap } from '@/config/company';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  emits: ['activate'],
  setup: function setup(__props, _ref) {
    var _window$AppConfig;

    var emit = _ref.emit;
    var route = useRoute();
    var store = useStore();

    var _ref2 = ((_window$AppConfig = window.AppConfig) === null || _window$AppConfig === void 0 ? void 0 : _window$AppConfig.corporation) || {},
        _ref2$showServiceLife = _ref2.showServiceLife,
        showServiceLife = _ref2$showServiceLife === void 0 ? true : _ref2$showServiceLife,
        _ref2$showActivateTag = _ref2.showActivateTag,
        showActivateTag = _ref2$showActivateTag === void 0 ? false : _ref2$showActivateTag,
        _ref2$showProductsOnC = _ref2.showProductsOnCloud,
        showProductsOnCloud = _ref2$showProductsOnC === void 0 ? false : _ref2$showProductsOnC,
        _ref2$showMoreVersion = _ref2.showMoreVersion,
        showMoreVersion = _ref2$showMoreVersion === void 0 ? false : _ref2$showMoreVersion,
        _ref2$allowExperience = _ref2.allowExperienceDemo,
        allowExperienceDemo = _ref2$allowExperience === void 0 ? true : _ref2$allowExperience;

    var _window$AppConfig2 = window.AppConfig,
        isCloudVersion = _window$AppConfig2.isCloudVersion,
        isPrivateEnv = _window$AppConfig2.isPrivateEnv;
    var code = ref('');
    var legal = ref(true);
    var codeMatch = ref(true);
    var activeModalVisible = ref(false); // 过期状态（0未开通，1已开通，2即将过期，3已过期）

    var status = ref('');
    var activateType = ref(''); // 激活类型：'OPEN'开通、'UPGRADE'升级、'RENEW'续费

    var appKey = computed(function () {
      return route.params.appKey;
    });
    var data = computed(function () {
      var originalAppList = store.state.company.appList;

      if (showProductsOnCloud) {
        originalAppList = originalAppList.map(function (app) {
          var _cloudAppInfoMap$app$, _cloudAppInfoMap$app$2;

          return _objectSpread(_objectSpread({}, app), {}, {
            appName: "".concat((_cloudAppInfoMap$app$ = cloudAppInfoMap[app.appKey]) === null || _cloudAppInfoMap$app$ === void 0 ? void 0 : _cloudAppInfoMap$app$.alias, " \u817E\u8BAF\u4E91\u57FA\u7840\u7248"),
            introImg: (_cloudAppInfoMap$app$2 = cloudAppInfoMap[app.appKey]) === null || _cloudAppInfoMap$app$2 === void 0 ? void 0 : _cloudAppInfoMap$app$2.introImg
          });
        });
      }

      return originalAppList.find(function (item) {
        return item.appKey === appKey.value;
      });
    });
    var corporationId = computed(function () {
      return route.params.company_id;
    });
    var appData = computed(function () {
      return appFeature[appKey.value] || appFeature.beacon_olap;
    });
    var activeData = computed(function () {
      var _data$value;

      if (!data.value) {
        return null;
      }

      if (!((_data$value = data.value) !== null && _data$value !== void 0 && _data$value.configMap)) {
        return data.value;
      }

      return _objectSpread(_objectSpread({}, data.value), {}, {
        detail: JSON.parse(data.value.configMap)
      });
    });

    var closeActiveModal = function closeActiveModal() {
      activeModalVisible.value = false;
      code.value = '';
    };

    var comfirmActive = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var _renewData$data, renewData, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!codeMatch.value || !legal.value)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", ElMessage({
                  message: '激活码无效',
                  type: 'error'
                }));

              case 2:
                if (!(activateType.value === 'RENEW')) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return store.dispatch('company/renewCompany', {
                  corporationId: corporationId.value,
                  activeCode: code.value
                });

              case 5:
                renewData = _context.sent;

                if (((_renewData$data = renewData.data) === null || _renewData$data === void 0 ? void 0 : _renewData$data.code) === 1) {
                  ElMessage({
                    message: '续费成功',
                    type: 'success'
                  });
                  emit('activate', appKey.value);
                  closeActiveModal();
                } else {
                  ElMessage({
                    message: renewData.data.msg,
                    type: 'error'
                  });
                }

                return _context.abrupt("return");

              case 8:
                _context.next = 10;
                return store.dispatch('company/createCompany', {
                  corporationId: corporationId.value,
                  activeCodes: code.value
                });

              case 10:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  ElMessage({
                    message: '开通成功',
                    type: 'success'
                  });
                  emit('activate', appKey.value);
                  closeActiveModal();
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function comfirmActive() {
        return _ref3.apply(this, arguments);
      };
    }();

    var openDemoPage = function openDemoPage() {
      window.open("/spacelist?corp_id=demo&app_key=".concat(appKey.value));
    }; // 校验激活码有效性


    var checkCodeLegal = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data2;

        var data, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (code.value.includes(appKey.value)) {
                  _context2.next = 3;
                  break;
                }

                codeMatch.value = false;
                return _context2.abrupt("return");

              case 3:
                codeMatch.value = true;
                _context2.next = 6;
                return CompanyService.queryActiveCode({
                  activeCodes: [code.value]
                });

              case 6:
                data = _context2.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  result = data.data.result[0];
                  legal.value = !!result.appName && !!result.appKey;
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function checkCodeLegal() {
        return _ref4.apply(this, arguments);
      };
    }(); // 升级


    var activate = function activate(type) {
      activateType.value = type;
      activeModalVisible.value = true;
    }; // 弹窗title


    var activateShow = function activateShow(activateType) {
      if (activateType === 'UPGRADE') return '升级';
      if (activateType === 'OPEN') return '开通';
      if (activateType === 'RENEW') return '续费';
    };

    var activeCurrentApp = function activeCurrentApp() {
      if (isCloudVersion) {
        window.open('https://buy.cloud.tencent.com/ida', '_blank');
        return;
      }

      activate('OPEN');
    };

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _unref(activeData) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["app-info", "status_".concat(_unref(activeData).expiredState)]),
        ref: "appInfo"
      }, [_unref(activeData).expiredState === 1 || _unref(activeData).expiredState === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString(_unref(activeData).currentVersion), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(_unref(activeData).startTime), 1)]), _createElementVNode("p", null, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(_unref(activeData).endTime), 1)]), _unref(showServiceLife) ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_unref(activeData).detail && _unref(activeData).detail.availableTime || '-'), 1)])) : _createCommentVNode("", true), _createElementVNode("p", null, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(activeData).remainingTime) + " 天", 1)]), !_unref(isPrivateEnv) ? (_openBlock(), _createElementBlock("p", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_unref(activeData).detail && _unref(activeData).detail.availableAccounts || 0) + "账号 / 空间", 1)])) : _createCommentVNode("", true), _unref(showActivateTag) ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_hoisted_14, !!_unref(activeData).bizObjs ? (_openBlock(), _createElementBlock("span", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeData).bizObjs, function (item, index) {
        return _openBlock(), _createElementBlock("span", {
          key: item.id
        }, _toDisplayString(index !== 0 ? '、' : '') + _toDisplayString(item.name), 1);
      }), 128))])) : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))])) : _createCommentVNode("", true)]), !_unref(isPrivateEnv) && _unref(activeData).detail && _unref(activeData).detail.canUpgrade ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "primary-button upgrade",
        type: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return activate('UPGRADE');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_17];
        }),
        _: 1
      })) : _createCommentVNode("", true), !_unref(isPrivateEnv) && _unref(appKey) !== 'dataprofile' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "primary-button renew",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return activate('RENEW');
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_18];
        }),
        _: 1
      })) : _createCommentVNode("", true), _unref(showMoreVersion) && _unref(showActivateTag) && _unref(appKey) === 'data_talk' ? (_openBlock(), _createElementBlock("a", _hoisted_19, "了解更多版本")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_unref(isCloudVersion) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "introImg",
        src: _unref(data).introImg
      }, null, 8, _hoisted_21)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["info", _unref(appKey)])
      }, [_createElementVNode("p", _hoisted_22, _toDisplayString(_unref(appData).title), 1), _createElementVNode("p", _hoisted_23, [_createElementVNode("span", null, _toDisplayString(_unref(appData).feature), 1), _createTextVNode(_toDisplayString(_unref(appData).subtitle), 1)]), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).tagList, function (item) {
        return _openBlock(), _createElementBlock("span", {
          key: item
        }, _toDisplayString(item), 1);
      }), 128))]), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).detail, function (item, index) {
        return _openBlock(), _createElementBlock("p", {
          key: index
        }, [_hoisted_26, _createElementVNode("span", null, _toDisplayString(item), 1)]);
      }), 128))])], 2)), _createVNode(_component_el_button, {
        class: _normalizeClass(['primary-button', 'edit-info', {
          ml60: _unref(isCloudVersion)
        }]),
        type: "primary",
        onClick: activeCurrentApp
      }, {
        default: _withCtx(function () {
          return [_hoisted_27];
        }),
        _: 1
      }, 8, ["class"]), _unref(allowExperienceDemo) && _unref(appKey) !== 'dataprofile' && _unref(appKey) !== 'abtest' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "link-button edit-info",
        type: "text",
        onClick: openDemoPage
      }, {
        default: _withCtx(function () {
          return [_hoisted_28];
        }),
        _: 1
      })) : _createCommentVNode("", true)])), _createVNode(_component_el_dialog, {
        title: "",
        modelValue: activeModalVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return activeModalVisible.value = $event;
        }),
        "custom-class": "custom-modal active-modal",
        width: "480px",
        height: "268px",
        onClose: closeActiveModal
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_42, [_createVNode(_component_el_button, {
            onClick: closeActiveModal
          }, {
            default: _withCtx(function () {
              return [_hoisted_43];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: comfirmActive
          }, {
            default: _withCtx(function () {
              return [_hoisted_44];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_29, _toDisplayString(activateShow(activateType.value)) + " " + _toDisplayString(_unref(activeData).appName), 1), _createVNode(_component_el_input, {
            class: "custom-input upgrade-code",
            modelValue: code.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return code.value = $event;
            }),
            placeholder: "请输入已购买产品的激活码",
            autocomplete: "off",
            onInput: checkCodeLegal
          }, null, 8, ["modelValue"]), code.value && !codeMatch.value ? (_openBlock(), _createElementBlock("p", _hoisted_30, _hoisted_33)) : _createCommentVNode("", true), code.value && !legal.value ? (_openBlock(), _createElementBlock("p", _hoisted_34, _hoisted_37)) : _createCommentVNode("", true), _unref(appKey) === 'data_talk' ? (_openBlock(), _createElementBlock("p", _hoisted_38, _hoisted_41)) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["modelValue"])], 2)) : _createCommentVNode("", true);
    };
  }
});